var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-review-card" },
    [
      _c("rt-picture", {
        staticClass: "quote-icon",
        attrs: { src: "/assets/app/class/icon-dobule-quote.svg" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "feedback-wrapper" }, [
        _c("h3", { staticClass: "feddback-content" }, [
          _vm._v(_vm._s(_vm.reviewer.feedback)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "user-info-wrapper flex-wrapper" }, [
          _c("img", {
            staticClass: "user-avatar",
            attrs: { src: _vm.reviewer.icon },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "name-info-wrapper" }, [
            _c("div", { staticClass: "user-name-wrapper flex-wrapper" }, [
              _c("h4", { staticClass: "user-name" }, [
                _vm._v(_vm._s(_vm.reviewer.name)),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "user-role" }, [
              _vm._v(_vm._s(_vm.reviewer.role)),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }